import React, { useState, useEffect } from 'react';
import { ListItem, ListItemText } from '@material-ui/core';
import { useRootStore } from '../../../stores/BridgeProvider';
import { useSnackBars } from '../../../alerts/SnackBarProvider';
import { COLORS } from '../../util/Colors';

const Security = () => {
  const { authStore } = useRootStore();
  const [accountInfo, setAccountInfo] = useState(null);
  const handleAlert = useSnackBars();

  const handleClick = async () => {
    const { Email, Name } = accountInfo;
    await authStore.request
      .post(`${process.env.REACT_APP_API}/api/change-password`, {
        email: Email,
        first_name: Name,
      })
      .then(response => {
        const { data } = response;

        if (data.status === 200) {
          handleAlert(data.message, COLORS.green);
        } else {
          handleAlert(data.message, COLORS.red);
        }
      });
  };

  useEffect(() => {
    const getAccountInfo = async () => {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/user`,
      );
      setAccountInfo(data);
    };
    getAccountInfo();
  }, []);

  return (
    <div style={{ margin: '12px' }}>
      <ListItem
        style={{ cursor: 'pointer' }}
        onClick={() => {
          handleClick();
        }}
      >
        <ListItemText
          primary="Change Password"
          secondary="will send a link to your account email address to reset your password"
          primaryTypographyProps={{ variant: 'h5' }}
        />
      </ListItem>
    </div>
  );
};

export default Security;
